import _objectSpread from "/home/runner/work/mozio-web/mozio-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _objectWithoutProperties from "/home/runner/work/mozio-web/mozio-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["shouldFocusWrap", "onKeyDown", "onKeyUp"];
import { menuData as $fc79756100351201$export$6f49b4016bfc8d56 } from "./utils.module.js";
import { filterDOMProps as $ieN2F$filterDOMProps, mergeProps as $ieN2F$mergeProps } from "@react-aria/utils";
import { useSelectableList as $ieN2F$useSelectableList } from "@react-aria/selection";
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */

function $d5336fe17ce95402$export$38eaa17faae8f579(props, state, ref) {
  var _props$shouldFocusWra = props.shouldFocusWrap,
      shouldFocusWrap = _props$shouldFocusWra === void 0 ? true : _props$shouldFocusWra,
      onKeyDown = props.onKeyDown,
      onKeyUp = props.onKeyUp,
      otherProps = _objectWithoutProperties(props, _excluded);

  if (!props['aria-label'] && !props['aria-labelledby'] && process.env.NODE_ENV !== 'production') console.warn('An aria-label or aria-labelledby prop is required for accessibility.');
  var domProps = (0, $ieN2F$filterDOMProps)(props, {
    labelable: true
  });

  var _ref = (0, $ieN2F$useSelectableList)(_objectSpread(_objectSpread({}, otherProps), {}, {
    ref: ref,
    selectionManager: state.selectionManager,
    collection: state.collection,
    disabledKeys: state.disabledKeys,
    shouldFocusWrap: shouldFocusWrap,
    linkBehavior: 'override'
  })),
      listProps = _ref.listProps;

  (0, $fc79756100351201$export$6f49b4016bfc8d56).set(state, {
    onClose: props.onClose,
    onAction: props.onAction,
    shouldUseVirtualFocus: props.shouldUseVirtualFocus
  });
  return {
    menuProps: (0, $ieN2F$mergeProps)(domProps, {
      onKeyDown: onKeyDown,
      onKeyUp: onKeyUp
    }, _objectSpread(_objectSpread({
      role: 'menu'
    }, listProps), {}, {
      onKeyDown: function onKeyDown(e) {
        var _listProps_onKeyDown; // don't clear the menu selected keys if the user is presses escape since escape closes the menu


        if (e.key !== 'Escape' || props.shouldUseVirtualFocus) (_listProps_onKeyDown = listProps.onKeyDown) === null || _listProps_onKeyDown === void 0 ? void 0 : _listProps_onKeyDown.call(listProps, e);
      }
    }))
  };
}

export { $d5336fe17ce95402$export$38eaa17faae8f579 as useMenu };